import { createSlice } from "@reduxjs/toolkit";
import { fetchCustomers } from "./customersDuck";
import trendsReducer, { trendsDefaultState } from "../../src/Dashboard/ducks/trendsDuck";
import alarmsHistoryReducer, { alarmsHistoryDefaultState } from "../../src/Dashboard/ducks/alarmsHistoryDuck";
import alarmsLimitsReducer, { alarmsLimitsDefaultState } from "../../src/Dashboard/ducks/alarmsLimitsDuck";
import reportsReducer, { reportsDefaultState } from "../../src/Dashboard/ducks/reportsDuck";

const isHistoricalAction = (action) => {
  const systemId = action.payload?.systemId || action.meta?.arg?.systemId;
  if (!systemId) return false;
  const t = action.type;
  return (
    t.startsWith("trends/") ||
    t.startsWith("alarmsHistory/") ||
    t.startsWith("alarmsLimits/") ||
    t.startsWith("reports/")
  );
};

const historicalTierSlice = createSlice({
  name: "historical",
  initialState: {},
  reducers: {
    initializeDeviceHistorical(state, action) {
      const { systemId } = action.payload;
      if (!state[systemId] || !state[systemId]._initialized) {
        state[systemId] = {
          trends: trendsDefaultState,
          alarmsHistory: alarmsHistoryDefaultState,
          alarmsLimits: alarmsLimitsDefaultState,
          reports: reportsDefaultState,
          _initialized: true,
        };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomers.fulfilled, (state, action) => {
        const systems = [];
        action.payload.length > 0 &&
          action.payload.forEach((customer) => systems.push(...customer.devices));
        systems.forEach((sys) => {
          if (!state[sys.deviceId]) {
            state[sys.deviceId] = { _initialized: false };
          }
        });
      })
      .addMatcher(isHistoricalAction, (state, action) => {
        const systemId = action.payload?.systemId || action.meta?.arg?.systemId;
        if (systemId && state[systemId]?._initialized) {
          state[systemId].trends = trendsReducer(state[systemId].trends, action);
          state[systemId].alarmsHistory = alarmsHistoryReducer(state[systemId].alarmsHistory, action);
          state[systemId].alarmsLimits = alarmsLimitsReducer(state[systemId].alarmsLimits, action);
          state[systemId].reports = reportsReducer(state[systemId].reports, action);
        }
      });
  },
});

export const { initializeDeviceHistorical } = historicalTierSlice.actions;
export default historicalTierSlice.reducer;
